export function formatPhoneNumber(phoneNumber?: string) {
  if (!phoneNumber) return "-";
  let formattedVal = phoneNumber.replace("+972", "0");

  // Format the phone number as XXX-XXX-XXXXX
  formattedVal = formattedVal.replace(/^(\d{3})(\d{3})(\d+)$/, "$1-$2-$3");

  return formattedVal;
}
